export default "__VITE_ASSET__Etdgzyp0__"